import {AuctionStatisticValue} from "components/Statistic/Cards/AuctionedVehiclesStatistic"
import {Indicators} from "domain-models"
import {store} from "store"

export interface SetIndicators {
  type: 'FETCH_INDICATORS',
  indicators: Indicators
}

export const setIndicators: (indicators: Indicators) => SetIndicators = indicators => ({
  type: 'FETCH_INDICATORS',
  indicators
})

export const fetchIndicators = async () => {
  const indicators = await window.axios.get('/performance-indicators')
  store.dispatch(setIndicators(indicators.data))
}

export const changeAuctionedFilter = async (filter: AuctionStatisticValue) => {
  const indicators = await window.axios.post<{indicator: number}>('/performance-indicators/auctioned', {filter})
  store.dispatch(setIndicators({
    ...store.getState().indicators,
    auctioned: indicators.data.indicator
  }))
}
